import React, { CSSProperties } from 'react';
import { Icon } from 'antd';

interface ArrowProp {
  text: string;
  linkUrl: string;
  style?: CSSProperties;
  className?: string;
  colour?: string;
}

const style: CSSProperties = {
  fontSize: '20px',
  fontWeight: 400,
  width: '234px',
  letterSpacing: '0.04px',
  lineHeight: '24px',
  textAlign: 'left'
};
//
export default function ArrowLink(props: ArrowProp) {
  const { linkUrl, colour, className } = props;

  return (
    <a
      href={linkUrl}
      className={colour ? `${className} ${colour}` : className}
      style={{ ...style, ...props.style }}
    >
      {props.text} <Icon type="arrow-right" />
    </a>
  );
}
